import { useNavigate, useParams } from "react-router-dom";
import { VariationUpdateForm } from "../../ui-components";
import { Flex, Heading, Link } from "@aws-amplify/ui-react";
import { Helmet } from "react-helmet";
import { I18n } from "aws-amplify/utils";
import { FaArrowLeft } from "react-icons/fa6";
import { Schema } from "../../../amplify/data/resource";
import { generateClient } from "aws-amplify/api";
import React from "react";

const client = generateClient<Schema>();

type Pattern = Schema["Pattern"]["type"];
type DanceStyle = Schema["DanceStyle"]["type"];

export default function VariationUpdate() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [danceStyles, setDanceStyles] = React.useState<DanceStyle[]>(
    {} as DanceStyle[]
  );
  const [patterns, setPatterns] = React.useState<Pattern[]>({} as Pattern[]);

  React.useEffect(() => {
    client.models.Pattern.observeQuery().subscribe({
      next: ({ items }) => {
        setPatterns(items);
      },
    });
    client.models.DanceStyle.observeQuery().subscribe({
      next: ({ items }) => {
        setDanceStyles(items);
      },
    });
  }, [id]);

  return (
    <Flex gap="1rem" direction="column">
      <Helmet>
        <title>{I18n.get("Edit Variation")}</title>
      </Helmet>
      <Flex marginTop={"1rem"}>
        <Heading level={1}>{I18n.get("Edit Variation")}</Heading>
      </Flex>
      <Flex>
        <Link onClick={() => navigate(-1)}>
          <FaArrowLeft aria-label={I18n.get("Back")} />
        </Link>
      </Flex>
      <Flex>
        <VariationUpdateForm
          id={id}
          patterns={patterns}
          danceStyles={danceStyles}
          onSuccess={() => navigate(-1)}
        />
      </Flex>
    </Flex>
  );
}
